import { useAuthInfo } from "../../hooks";
import { ReactNode } from "react";
export default function IfNotObserver(p: {
    children: ReactNode | ReactNode[],
}) {
    const { loadingAuthInfo, isObserver } = useAuthInfo();
    if (loadingAuthInfo) return <span></span>;
    if (isObserver) return <span></span>
    return <>{p.children}</>;
}